// extracted by mini-css-extract-plugin
export default {"root":"_2_LjS","expanded":"_2YLVm"};